export const getInputHelperID = (id: string) => `${id}-helper-text`
export const getInputLabelID = (id: string) => `${id}-label`
